import React from "react";
import { LoadingRing } from "./loadingSpinner.style";

const LoadingSpinner = ({ variant, ...props }) => {
    switch (variant) {
        default:
            return (
                <LoadingRing {...props}>
                    <div/>
                    <div/>
                    <div/>
                    <div/>
                </LoadingRing>
            )
    }
};

export default LoadingSpinner;
